<mat-card class="usage-detail-card" *ngIf="organization">
  <div class="organization-name">
    {{ resolveName(organization.name) }}
  </div>

  <div class="separator"></div>

  <div class="workspaces-container">
    <span class="workspace-chip" *ngFor="let workspace of workspaceList" [title]="resolveName(workspace.name)">
      {{ resolveName(workspace.name) }}
    </span>
  </div>
</mat-card>
